import { render, staticRenderFns } from "./inovice.vue?vue&type=template&id=12f64c83&scoped=true"
import script from "./inovice.vue?vue&type=script&lang=ts"
export * from "./inovice.vue?vue&type=script&lang=ts"
import style0 from "./inovice.vue?vue&type=style&index=0&id=12f64c83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f64c83",
  null
  
)

export default component.exports